import { render, staticRenderFns } from "./ImgModal.vue?vue&type=template&id=9ceaf676&scoped=true&"
import script from "@/scripts/QA/Question/components/ImgModal?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/ImgModal?vue&type=script&lang=js&"
import style0 from "./ImgModal.vue?vue&type=style&index=0&id=9ceaf676&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ceaf676",
  null
  
)

export default component.exports